// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CreateSocialItemModal-cls1___145ac1d2ac5d869e54c{/*!*/}.CreateSocialItemModal-cls2__c3c2772c077d05ea0583{display:flex;flex:1 1}.CreateSocialItemModal-cls2__c3c2772c077d05ea0583.CreateSocialItemModal-center___1d80dd4d6888632d67d{padding-top:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "CreateSocialItemModal-cls1___145ac1d2ac5d869e54c",
	"cls2": "CreateSocialItemModal-cls2__c3c2772c077d05ea0583 CreateSocialItemModal-cls1___145ac1d2ac5d869e54c",
	"center": "CreateSocialItemModal-center___1d80dd4d6888632d67d"
};
export default ___CSS_LOADER_EXPORT___;
